/**
 * Application-wide constants
 */

// Image processing constants
export const DEFAULT_MAX_IMAGE_SIZE = 1024; // Default max dimension in pixels for image resizing
export const MAX_IMAGE_FILE_SIZE = 10 * 1024 * 1024; // 10MB absolute maximum for base64 images
export const MIN_IMAGE_SIZE = 128; // Minimum allowed image size
export const MAX_PREMIUM_IMAGE_SIZE = 8192; // Maximum size for premium users
export const IMAGE_QUALITY = 0.9; // JPEG quality for resized images (0.9 = 90%)

// Usage limits - character counts per day
export const USAGE_LIMITS = {
  ANONYMOUS_DAILY: 1000,    // 1,000 characters per day for anonymous users
  REGISTERED_DAILY: 5000,  // 5,000 characters per day for registered users
} as const;

// Single translation limits
export const SINGLE_TRANSLATION_LIMITS = {
  MAX_CHARACTERS: 140000,    // Conservative estimate for 65.5K output tokens (~2 chars per token)
  PREMIUM_MAX_CHARACTERS: 140000,  // Future premium model limit
} as const;

// Starky Sense limits
export const STARKY_SENSE_LIMITS = {
  PARALLEL_MODE_THRESHOLD: 1000000,  // Characters threshold for parallel vs modal mode, it's 1 million so practically disabled - I dont want to deal with the complexity of modal mode right now.

} as const;
